import styled from "@emotion/styled"
import { NewText } from "ui"
import { extractProperty } from "utils"

import AccordionItemWithIcon from "./AccordionItemWithIcon"

const StyledContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 56px;
    margin-bottom: 50px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-top: 80px;
    margin-bottom: 68px;
  }
`

const StyledAccordionContainer = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  margin-top: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 30px;
  }

  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-top: 40px;
  }
`
const Padding = styled.div`
  padding: 0 28px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 220px;
  }
`

type Props = {
  data: any
}

function AccordionFaqWithIcon({ data }: Props) {
  const mainTitle = extractProperty(data, "mainTitle")
  const accordionInner = extractProperty(data, "accordionInner")
  return (
    <Padding>
      <StyledContainer>
        <NewText
          component={"h1"}
          largeDesktopFontSize={64}
          desktopFontWeight={500}
          largeDesktopLineHeight={"76.4px"}
          desktopFontSize={50}
          desktopLineHeight="60px"
          mobileFontSize={36}
          mobileLineHeight="50.4px"
        >
          {mainTitle}
        </NewText>
        <StyledAccordionContainer>
          {accordionInner.map((item: any, index: number) => (
            <li key={index.toString()}>
              <AccordionItemWithIcon data={item} defaultOpen={index === 0} />
            </li>
          ))}
        </StyledAccordionContainer>
      </StyledContainer>
    </Padding>
  )
}

export default AccordionFaqWithIcon
